import { useQuery } from "@tanstack/react-query"
import { useApi } from "../views/hooks/useApi"
import { Fundamentals } from "../api/fundamentalsApi"

interface UseFundamentalsDisplayDataProps {
  company_id?: number
  enabled?: boolean
}

export const useFundamentalsDisplayData = ({
  company_id,
  enabled = true,
}: UseFundamentalsDisplayDataProps) => {
  const { scientApi } = useApi()

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["fundamentalsDisplayData", company_id],
    queryFn: async (): Promise<Fundamentals> => {
      if (!company_id) {
        throw new Error("Company ID is required")
      }
      return await scientApi.fundamentals.getDisplayData(company_id)
    },
    enabled: Boolean(company_id && enabled),
    staleTime: Infinity,
    retry: 2,
    select: (data: Fundamentals) => data,
  })

  return {
    data,
    error,
    isLoading,
    refetch,
    hasData: Boolean(data?.data?.rows?.length),
  }
}
